/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { representativesDelete } from "../../funcs/representativesDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteRepresentativeRequest$inboundSchema,
};

export const tool$representativesDelete: ToolDefinition<typeof args> = {
  name: "representatives-delete",
  description:
    `Deletes a business representative associated with a Moov account. Read our [business representatives guide](https://docs.moov.io/guides/accounts/requirements/business-representatives/) to learn more.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/representatives.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await representativesDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
